<div class="relative">
  <button
    data-testid="select-button"
    [id]="id() || 'select-button'"
    [name]="name() || 'select-name'"
    type="button"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    aria-labelledby="listbox-label"
    [disabled]="disabled()"
    class="grid w-full cursor-pointer grid-cols-1 rounded-lg input">
    <span class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
      <span class="block truncate text-base"
        >{{ selectedItem()?.label || 'Select an option' }}</span
      >
    </span>

    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      data-slot="icon"
      aria-hidden="true"
      class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4">
      <path
        d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
        clip-rule="evenodd"
        fill-rule="evenodd" />
    </svg>
  </button>

  @if (isOpen) {
  <ul
    role="listbox"
    tabindex="-1"
    aria-labelledby="listbox-label"
    class="absolute z-5 mt-1 max-h-56 w-full overflow-auto rounded-lg bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm transition ease-in duration-100 opacity-100">
    @for (item of items(); track item.value; let i = $index) {
    <li
      [id]="'listbox-option-' + i"
      role="option"
      tabindex="0"
      [attr.aria-selected]="isSelected(item)"
      (click)="selectItem(item)"
      (keydown.enter)="selectItem(item)"
      (keydown.space)="selectItem(item)"
      (mouseenter)="highlightedIndex = i"
      (mouseleave)="highlightedIndex = -1"
      class="relative cursor-pointer py-2 px-3 select-none transition-colors duration-150"
      [class.bg-primary]="isSelected(item)"
      [class.text-white]="isSelected(item)"
      [class.bg-gray-100]="highlightedIndex === i && !isSelected(item)"
      [class.text-black]="highlightedIndex === i && !isSelected(item)"
      [class.text-gray-700]="highlightedIndex !== i && !isSelected(item)">
      <div class="flex items-center">
        <span class="block truncate">{{ item.label }}</span>
      </div>
    </li>
    }
  </ul>
  }
</div>
